import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

function hasOverflow(el) {
  if (!el) return false;
  return el.scrollWidth - el.clientWidth > 1 || el.scrollHeight - el.clientHeight > 1;
}

export default function Tooltip({ content, children, delay = 250, onlyWhenTruncated = true, className = '' }) {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const timeoutRef = useRef(null);
  const wrapperRef = useRef(null);

  const show = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const wrapper = wrapperRef.current;
      if (!wrapper) return;
      const child = wrapper.firstElementChild;
      if (onlyWhenTruncated && !hasOverflow(wrapper) && !hasOverflow(child)) return;
      const rect = (child || wrapper).getBoundingClientRect();
      setPos({ top: rect.top - 8, left: rect.left + rect.width / 2 });
      setVisible(true);
    }, delay);
  };

  const hide = () => {
    clearTimeout(timeoutRef.current);
    setVisible(false);
  };

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <>
      <span
        ref={wrapperRef}
        onMouseEnter={show}
        onMouseLeave={hide}
        className={className}
      >
        {children}
      </span>
      {visible &&
        content &&
        createPortal(
          <div
            style={{
              position: 'fixed',
              top: pos.top,
              left: pos.left,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999,
            }}
            className="bg-card border border-border rounded-md shadow-xl px-3 py-2 text-sm text-text-primary max-w-md pointer-events-none whitespace-normal break-words"
          >
            {content}
          </div>,
          document.body
        )}
    </>
  );
}
